import React from 'react';
import { useRef, useEffect, useState } from "react";
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

//Material UI depemdencies
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

//Other component dependencies
import BlueprintDrawerMenu from '../../components/molecules/blueprintLayout/BlueprintDrawerMenu';
import DashboardDrawerMenu from '../../components/molecules/layout/DashboardDrawerMenu';
import { getBlueprintDetails } from "../../store/global/selectors";


// import CssBaseline from '@material-ui/core/CssBaseline';

const drawerWidth = 64;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100vh',
        float: 'left'

    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        marginTop: 20
    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: '#364150',
        color: '#ffff00',
        zIndex: 1201
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        marginTop: '50%'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    iconButton: {
        margin: theme.spacing(1),
    },
    selectedIconButton: {
        backgroundColor: '#48566a',
    },
    image: {
        width: 35,
        height: 35
    },
    expandIcon: {
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        backgroundColor: '#fff',
        width: 24,
        height: 24,
        borderRadius: '50%',
        zIndex: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        color: '#000'
    },
    snackBar: {
        top: '2rem',
        right: '6rem'
    }

}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const FixedDrawer = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
    const history = useHistory();

    const [open, setOpen] = React.useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [selectedIndex, setSelectedIndex] = useState(500);
    const [readonlyMode, setReadonlyMode] = useState(false);
    const [openUserPop, setopenUserPop] = useState(null);
    const [uIndex, setIndex] = useState(10);


    const blueprintDetails = useSelector(getBlueprintDetails);


    const isPathBlueprint = props.location.pathname.indexOf('/blueprint/') > -1;
    const [, , id, tag] = history.location.pathname.split("/");



    const setWindowDimensions = () => {
        setWindowWidth(window.innerWidth);
        setWindowHeight(window.innerHeight);
    }

    const usePrevious = (value) => {
        const ref = useRef();

        useEffect(() => {
            ref.current = value;
        }, [value]);

        return ref.current;
    };

    const previousTag = usePrevious(tag);


    useEffect(() => {
        window.addEventListener('resize', setWindowDimensions);
        return () => {
            window.removeEventListener('resize', setWindowDimensions);
        }
    }, [])


    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };


    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };


    const handleClickUserPop = (event) => {
        setopenUserPop(event.currentTarget);
    };

    const userPopOverClose = () => {
        setopenUserPop(null);

    };

    return (
        <div className={classes.root}>
            <CssBaseline />

            {readonlyMode && <Snackbar
                open={true}
                message={process.env.REACT_APP_READONLY_INFO}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                className={classes.snackBar}>
                <Alert severity='warning'>
                    {process.env.REACT_APP_READONLY_INFO}
                </Alert>
            </Snackbar>
            }


            {!props.drawerOpen &&
                <Box
                    id="open_sidebar_btn"
                    onClick={props.toggleSideDrawer}
                    style={{
                        position: 'fixed',
                        top: '50%', // Adjust up/down as needed
                        left: 'calc(64px - 12px)', // drawerWidth - small offset (~8–12px)
                        transform: 'translateY(-50%)',
                        zIndex: 1301,
                        background: '#2f3e55',
                        color: '#fff',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0 0 4px rgba(0,0,0,0.4)',
                    }}
                >
                    <ChevronRightIcon fontSize="small" />
                </Box>
            }


            <Drawer
                className={classes.drawer}
                variant="permanent"
                anchor="left"
                open={true}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                {windowHeight > 250 && <>

                    {isPathBlueprint && <BlueprintDrawerMenu />}
                    {!isPathBlueprint && <DashboardDrawerMenu />}



                </>}
                {/* {windowHeight <= 250 && <IconButton onClick={(event) => handleIconButtonClick(event, 4)}>
                    <DragIndicatorIcon style={{ marginTop: '70px', color: '#ffff00' }} />
                </IconButton>} */}


            </Drawer>


        </div>
    );
}
export default withRouter(FixedDrawer);